import React from "react";
import { useTranslation } from "react-i18next";
import "./about.css";

const AUDIENCES = [
  {
    key: "clients",
    icon: "fas fa-user-friends",
    points: [
      { icon: "far fa-calendar-check", text: "about_clients_1" },
      { icon: "far fa-comments", text: "about_clients_2" },
      { icon: "far fa-lightbulb", text: "about_clients_3" },
    ],
  },
  {
    key: "lawyers",
    icon: "fas fa-balance-scale",
    points: [
      { icon: "fas fa-briefcase", text: "about_lawyers_1" },
      { icon: "far fa-clock", text: "about_lawyers_2" },
      { icon: "fas fa-reply", text: "about_lawyers_3" },
    ],
  },
];

export default function AboutSection() {
  const { t } = useTranslation();
  return (
    <>
      <section className="avc-page-hero">
        <div className="container avc-page-hero__inner">
          <span className="avc-eyebrow">
            <i className="fas fa-balance-scale" aria-hidden="true"></i>
            {t("AboutUs")}
          </span>
          <h1 className="avc-page-hero__title">{t("about_title")}</h1>
          <p className="avc-page-hero__lead">{t("about_lead")}</p>
        </div>
      </section>

      <section className="avc-about">
        <div className="container">
          <div className="avc-about__grid">
            {AUDIENCES.map((audience) => (
              <article className="avc-audience" key={audience.key}>
                <span className="avc-audience__icon">
                  <i className={audience.icon} aria-hidden="true"></i>
                </span>
                <h2 className="avc-audience__title">
                  {t(`about_${audience.key}_title`)}
                </h2>
                <ul className="avc-audience__list">
                  {audience.points.map((point) => (
                    <li key={point.text}>
                      <i className={point.icon} aria-hidden="true"></i>
                      <span>{t(point.text)}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
